/** @jsx jsx */
import React, { type ReactNode } from 'react';
import { cssMap, styled, jsx } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { components, type OptionProps } from '@atlaskit/select';

import { token } from '@atlaskit/tokens';

import Team from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/other/components/team/index.tsx';
import type { TeamFieldType } from '../../../common/types.tsx';

type Props = {
	data: TeamFieldType;
	children: ReactNode;
};

const optionStyles = cssMap({
	root: {
		paddingBlockStart: token('space.0'),
		paddingBlockEnd: token('space.0'),
		paddingInlineStart: token('space.0'),
		paddingInlineEnd: token('space.0'),
	},
});

const OptionComponent = (props: Props & OptionProps): JSX.Element | null => {
	const value = props.data;
	if (value) {
		const { avatarUrl, label } = value;

		return (
			<components.Option {...props} xcss={optionStyles.root}>
				<OptionWrapper>
					{avatarUrl ? (
						<Icon src={avatarUrl} alt={label} />
					) : (
						<Box xcss={boxStyle}>
							<Team alt="" />
						</Box>
					)}

					<OptionText>{props.children}</OptionText>
				</OptionWrapper>
			</components.Option>
		);
	}
	return null;
};

export default OptionComponent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled.img({
	width: '16px',
	height: '16px',
	marginRight: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	overflow: 'hidden',
	alignItems: 'center',
	justifyContent: 'start',
	paddingBlockStart: token('space.0'),
	paddingInlineEnd: token('space.050'),
	paddingBlockEnd: token('space.0'),
	paddingInlineStart: token('space.050'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionText = styled.div({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

const boxStyle = xcss({
	height: '16px',
	width: '16px',
	marginRight: 'space.100',
});
